import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';

export const jwtInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const auth = inject(AuthenticationService);
  const language = (localStorage.getItem('lang') || document.documentElement.lang || 'ar').toLowerCase();
  const normalizedLanguage = language.startsWith('en') ? 'en' : 'ar';

  const headers: Record<string, string> = {
    'Accept-Language': normalizedLanguage,
    'Access-Control-Expose-Headers': 'Content-Disposition',
  };

  try {
    const token = auth._token;
    if (token && !request.headers.has('Authorization') && !request.url.includes('/api/v1/auth/manager-login')) {
      headers['Authorization'] = `Bearer ${token}`;
    }
  } catch {
    localStorage.removeItem('vultToken');
    sessionStorage.removeItem('vultToken');
  }

  request = request.clone({ setHeaders: headers });
  return next(request);
};
